module.exports = __webpack_public_path__ + "img/LogoMettao.d2c460b1.png";